import { plural } from '@lingui/core/macro';
import { Box, Button } from '@pocketlaw/tetris';
import { Link } from 'react-router-dom';
import { constructSearchURL } from 'app/domains/global-search/utils/constructSearchURL';
import { useUniversalSearch } from './useUniversalSearch';
export function SearchPageLink() {
    const { searchText, closeSearchPopup, data, modifiers } = useUniversalSearch();
    const url = constructSearchURL({ query: searchText, modifiers, path: 'search' });
    const { results, totalHitsCount } = data;
    const additionalResultCount = totalHitsCount - (results.length || 0);
    const pluralResultCount = plural(additionalResultCount, {
        0: 'Go to search',
        one: 'Show # more result',
        other: 'Show # more results',
    });
    return (<Box alignItems="center" justifyContent="center" mt="xl">
      <Button as={Link} type="button" size="xs" appearance="secondary" to={url} onClick={closeSearchPopup}>
        {pluralResultCount}
      </Button>
    </Box>);
}
